module.exports = __webpack_public_path__ + "static/media/jorge.2d551540.jpeg";